import { h, Component, Fragment } from 'preact'
import cn from 'classnames'
import tdlib from '../../utils/tdlib'
import { Input } from '../../UI/Input'
import { ERROR_CODES } from '../../constants/errorCodes'
import AuthStep from '../AuthStep'
import s from './CodeForm.css'

interface iProps {
  phone: string | null
  onCancel: () => void
}

interface iState {
  errorCode: string | null,
  code: string
}

class CodeForm extends Component<iProps, iState> {
  state = {
    errorCode: null,
    code: ''
  }

  onChangeCode = (e: Event) => {
    const { value: code } = e.target as HTMLInputElement

    this.setState({
      errorCode: null,
      code
    })
  }

  submitForm = (e: Event) => {
    e.preventDefault()
    const { code } = this.state

    tdlib
      .send({
        '@type': 'checkAuthenticationCode',
        code
      })
      .then(() => {})
      .catch((err) => {
        const errorCode = (
          ERROR_CODES[err.message as 'PHONE_CODE_INVALID'] ||
          err.message
        )

        this.setState({ errorCode })
      })
  }

  render () {
    const { phone, onCancel } = this.props
    const { code, errorCode } = this.state

    return (
      <AuthStep
        image={(
          <div className={cn(s.CodeForm__icon, {
            [s.CodeForm__icon_error]: errorCode
          })}/>
        )}
        title={(
          <Fragment>
            {phone}
            <button
              type="button"
              className={s.CodeForm__edit}
              onClick={onCancel}
            />
          </Fragment>
        )}
        text={(
          `We have sent you an SMS 
          with the code.`
        )}
      >
        <form
          className={s.CodeForm}
          onSubmit={this.submitForm}
        >
          <Input
            label={errorCode || 'Code'}
            onInput={this.onChangeCode}
            value={code}
            name="code"
            invalid={!!errorCode}
            autoFocus
          />
        </form>
      </AuthStep>
    )
  }
}

export default CodeForm
